module.exports = __webpack_public_path__ + "ad7dd815212144df3d2c4f6375ed5bb6.jpg";